const calculatePercentage = (part, whole) => Math.round((((part * 100 / whole) + Number.EPSILON) * 100) / 100)

export default calculatePercentage
